import {DEFAULT_DATE_TIME_FORMAT} from '../constants';

/**
 * Determines the effective date format to use.
 * If time input is shown and the current format doesn't contain time tokens,
 * returns the default date-time format, otherwise returns the original format.
 *
 * @param isShownTimeInput - Whether time input should be shown
 * @param dateFormat - The current date format string
 * @returns The effective date format to use
 */
export const getEffectiveDateFormat = (
    isShownTimeInput: boolean,
    dateFormat?: string,
): string | undefined => {
    // If showTimeInput is true and dateFormat doesn't contain time tokens
    if (isShownTimeInput && dateFormat && !/[HhKkmsS]/.test(dateFormat)) {
        return DEFAULT_DATE_TIME_FORMAT;
    }

    return dateFormat;
};
